export enum PathUnit {
  AskBot = 'ask-bot',
  LandingPage = 'landing-page',
  Login = "login",
  PreRequisite = 'pre-requisite',
  NodeValidator = 'node-validator',
  // JobLookup = 'job-lookup',
  JobQuery = 'job-query',
  SystemOwners = 'system-owners',
  RoleValidator = 'role-validator',
  LiveMonitoring = 'live-monitoring',
  SoftwareCenter = 'software-center',
  SupportAgent = 'support-agent',
  Administrator = 'administrator',
  NotificationsMgmt = 'notifications-mgmt',
  SoftwareCenterUpload = 'software-center-upload',
  ComingSoon = 'comingsoon',
  SystemSettings = 'settings',
  SystemOwnersMgmt = 'system-owners-mgmt',
  RequestAccess = 'request-access',
  Forbidden = 'forbidden',
  Unauthorized = 'unauthorized',
  Unsubscribe = 'unsubscribe',
  AIContentManager = 'ai-content-manager',
  ClearCache = 'clear-cache',
  QualityDashboard = 'quality-dashboard',
  JobLogAnalysis = 'job-log-analysis',
}

export const PagePath = {
  [PathUnit.Login]: `${PathUnit.Login}`,
  [PathUnit.LandingPage]: `${PathUnit.LandingPage}`,
  [PathUnit.AskBot]: `${PathUnit.AskBot}`,
  [PathUnit.NodeValidator]: `${PathUnit.NodeValidator}`,
  [PathUnit.PreRequisite]: `${PathUnit.PreRequisite}`,
  // [PathUnit.JobLookup]: `${PathUnit.JobLookup}`,
  [PathUnit.JobQuery]: `${PathUnit.JobQuery}`,
  [PathUnit.SoftwareCenter]: `${PathUnit.SystemOwners}/${PathUnit.SoftwareCenter}`,
  [PathUnit.SoftwareCenterUpload]: `${PathUnit.SystemOwners}/${PathUnit.SoftwareCenter}/upload`,
  [PathUnit.LiveMonitoring]: `${PathUnit.SupportAgent}/${PathUnit.LiveMonitoring}`,
  [PathUnit.NotificationsMgmt]: `${PathUnit.Administrator}/${PathUnit.NotificationsMgmt}`,
  [PathUnit.SystemOwners]: `${PathUnit.SystemOwners}`,
  [PathUnit.SupportAgent]: `${PathUnit.SupportAgent}`,
  [PathUnit.Administrator]: `${PathUnit.Administrator}`,
  [PathUnit.RoleValidator]: `${PathUnit.RoleValidator}`,
  [PathUnit.ComingSoon]: `${PathUnit.ComingSoon}`,
  [PathUnit.SystemSettings]: `${PathUnit.Administrator}/${PathUnit.SystemSettings}`,
  [PathUnit.SystemOwnersMgmt]: `${PathUnit.Administrator}/${PathUnit.SystemOwnersMgmt}`,
  [PathUnit.AIContentManager]: `${PathUnit.Administrator}/${PathUnit.AIContentManager}`,
  [PathUnit.RequestAccess]: `${PathUnit.RequestAccess}`,
  [PathUnit.Forbidden]: `${PathUnit.Forbidden}`,
  [PathUnit.Unauthorized]: `${PathUnit.Unauthorized}`,
  [PathUnit.Unsubscribe]: `${PathUnit.Unsubscribe}`,
  [PathUnit.ClearCache]: `${PathUnit.Administrator}/${PathUnit.ClearCache}`,
  [PathUnit.QualityDashboard]: `${PathUnit.Administrator}/${PathUnit.QualityDashboard}`,
  [PathUnit.JobLogAnalysis]: `${PathUnit.SupportAgent}/${PathUnit.JobLogAnalysis}`,
}

export function getPath(pageName: PathUnit): string {
  return PagePath[pageName];
}